import { Layers, Layer } from '../../app'

function layersToArray(layers: Layers): Layer[] {
    if (!layers || typeof layers != 'object') return []
    return Object.keys(layers).reduce((current, layerId) => {
        return [...current, layers[layerId]]
    }, [])
}
export { layersToArray }
